import { FormDescriptionV2 } from './components/FormDescriptionV2/FormDescriptionV2'
import { PayMethodsV2 } from './components/PayMethodsV2/PayMethodsV2'
import { EmailInputV2 } from './components/Inputs/EmailInputV2'
import { PhoneInputV2 } from './components/Inputs/PhoneInputV2'
import { NameInputV2 } from './components/Inputs/NameInputV2'
import { OrderInfo } from './components/OrderInfo/OrderInfo'
import styles from './Main.module.scss'
import React from 'react'

export const Main = ({
  name,
  setName,
  phone,
  setPhone,
  email,
  setEmail,
  setInputsError,
  user,
  finsovetnik,
  bindingProduct,
  countSalesStatus,
  productsList,
  products,
  promoRes,
  currency,
  payment_method_id,
  setPayment_method_id,
  payMethodId,
  setNoIframe,
  setCurrency,
  duration,
  setDuration,
  setDurationErr,
  setPmidForPaytabs,
  selectedMethod,
  setSelectedMethod,
  hasNoPm,
  setHasNoPm
}) => {
  return (
    <div className={styles.root} data-testid="main-root">
      <div className={styles.inputsContent} data-testid="main-inputsContent">
        <div className={styles.title} data-testid="main-title">
          Получатель
        </div>

        <div className={styles.inputsGroup} data-testid="main-inputsGroup">
          <NameInputV2
            name={name}
            setName={setName}
            disFio={user?.fio}
            setInputsError={setInputsError}
          />
          <PhoneInputV2
            phone={phone}
            setPhone={setPhone}
            disPhone={user?.phone}
            setInputsError={setInputsError}
          />
          <EmailInputV2
            email={email}
            setEmail={setEmail}
            disEmail={user?.email}
            setInputsError={setInputsError}
          />
        </div>

        <FormDescriptionV2
          finsovetnik={finsovetnik}
          bindingProduct={bindingProduct}
          disEmail={user?.email}
          disFio={user?.fio}
          disPhone={user?.phone}
        />
      </div>

      <OrderInfo
        countSalesStatus={countSalesStatus}
        bindingProduct={bindingProduct}
        products={productsList ?? products}
        promoRes={promoRes}
        currency={currency}
      />

      <PayMethodsV2
        payment_method_id={payment_method_id}
        setPayment_method_id={setPayment_method_id}
        payMethodId={payMethodId}
        setNoIframe={setNoIframe}
        setCurrency={setCurrency}
        duration={duration}
        setDuration={setDuration}
        setDurationErr={setDurationErr}
        setPmidForPaytabs={setPmidForPaytabs}
        selectedMethod={selectedMethod}
        setSelectedMethod={setSelectedMethod}
        hasNoPm={hasNoPm}
        setHasNoPm={setHasNoPm}
      />

      {/* <DeliveryInfo /> */}
    </div>
  )
}
